import { WORDPRESS_SERVICE_URL } from '~/modules/config';

let scriptLoaded = false;

// In order to ensure we only load the dependent script once we have this common module to manage it
export function loadWordPressScript() {
    if (scriptLoaded) {
        return;
    }

    const wpScript = document.createElement('script');
    wpScript.src = `${WORDPRESS_SERVICE_URL}/wp-content/themes/appexchange/dist/js/elements.js`;
    wpScript.onload = () => {
        scriptLoaded = true;
    };
    wpScript.onerror = () => {
        console.error('Error loading WP elements script');
    };
    document.head.appendChild(wpScript);
}

export function htmlDecode(html: string) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    // eslint-disable-next-line @lwc/lwc/no-inner-html
    return doc.documentElement.innerHTML ?? '';
}
